import repository from "@/plugins/axios/secureClient";

const userdicsResource = "/user-dics";

export default {
  getDics() {
    return repository.get(`${userdicsResource}/`);
  },
  getList(dicId, params) {
    return repository.get(`${userdicsResource}/${dicId}/`, { params });
  },
  getOne(recordId) {
    return repository.get(`${userdicsResource}/record/${recordId}`);
  },
  create(dicId, payload) {
    return repository.post(`${userdicsResource}/${dicId}/`, payload);
  },
  update(recordId, payload) {
    return repository.put(`${userdicsResource}/${recordId}`, payload);
  },
  delete(recordId) {
    return repository.delete(`${userdicsResource}/${recordId}`);
  }
  /*getHistory(id) {
    return repository.get(`${userdicsResource}/${id}/history`);
  }*/
};
